import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFloodComponent } from './simple-icons-flood.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFloodComponent ],
    exports:      [ SimpleIconsFloodComponent ],
    bootstrap:    []
})
export class SimpleIconsFloodModule {}
